import { Component, OnInit, Input } from "@angular/core";
// import { Label, MultiDataSet, Colors } from "ng2-charts";
import { ChartType } from "chart.js";

@Component({
    selector: "app-property-equity-gain",
    templateUrl: "./property-equity-gain.component.html",
    styleUrls: ["./property-equity-gain.component.scss"],
    standalone: false
})
export class PropertyEquityGainComponent implements OnInit {
  constructor() {}
  @Input() public equityGain: number = 0;
  @Input() public equity: number = 0;
  @Input() public debt: number = 0; //will be zero for non primary resedence since we combine debt and expense into the asset value.
  public barChartLabels: string[] = [];
  public barChartLabelColors: { backgroundColor: string[] };
  public barChartData;
  public barChartType: ChartType = "bar";
  public chartOption;
  public showCanvas = false;
  public total;
  public equityHeight;
  public debtHeight;
  public diffHeight;
  public barHeight = 300; //px
  public barHeightText = this.barHeight + "px";
  public equityReal = 0;
  ngOnInit() {
    this.showCanvas = false;
    if (!this.equity) {
      this.equity = 0;
    }
    if (!this.debt) {
      this.debt = 0;
    }
    this.total = this.equity + this.debt;
    let totalMaxSum = Math.max(this.equity, this.debt);
    if (this.equity > 0) {
      this.equityHeight =
        Math.round((this.barHeight * this.equity) / totalMaxSum) + "px";
    }
    if (this.debt > 0) {
      this.debtHeight =
        Math.round((this.barHeight * this.debt) / totalMaxSum) + "px";
    }
    if (this.equity > 0 && this.debt > 0) {
      this.equityReal = this.equity - this.debt;
      this.diffHeight =
        this.barHeight -
        Math.round((this.barHeight * this.debt) / totalMaxSum) +
        "px";
    }
    console.log("EQUITY: " + this.equity + " DEBT: " + this.debt);
    // if (this.total > 0) {
    //   //this.barChartLabels = ["Equity Gain","Equity","Debt"];
    //   this.barChartData = [
    //     { data: [Math.round(this.equity)], label: 'Equity ' + Math.round(this.equity) },
    //     { data: [Math.round(this.debt)], label: 'Debt ' + Math.round(this.debt) }];
    //   this.chartOption = {
    //     responsive: true,
    //     scales: {
    //       yAxes: [
    //         {
    //           ticks: {
    //             beginAtZero: true
    //           }
    //         }
    //       ]
    //     }
    //   }
    //   this.showCanvas = true;
    // }
  }
}
